import React, { useState, useLayoutEffect } from 'react'
import './StepProgressBar.css'

export default function StepProgressBar({ steps, currentStepNumber }) {
	const [step, setStep] = useState([])

	useLayoutEffect(() => {
		const stepsState = steps.map((step, index) => {
			const stepObj = {}
			stepObj.description = step
			stepObj.completed = false
			stepObj.highlighted = index === 0 ? true : false
			stepObj.selected = index === 0 ? true : false
			stepObj.stepNum = index
			return stepObj
		})

		const currentSteps = updateStep(currentStepNumber - 1, stepsState)

		setStep(currentSteps)
	}, [steps, currentStepNumber])

	function updateStep(stepNumber, steps) {
		const newSteps = [...steps]

		let stepCounter = 0
		while (stepCounter < newSteps.length) {
			if (stepCounter === stepNumber) {
				newSteps[stepCounter] = {
					...newSteps[stepCounter],
					highlighted: true,
					selected: true,
					completed: false,
				}
				stepCounter++
			} else if (stepCounter < stepNumber) {
				newSteps[stepCounter] = {
					...newSteps[stepCounter],
					highlighted: false,
					selected: true,
					completed: true,
				}
				stepCounter++
			} else {
				newSteps[stepCounter] = {
					...newSteps[stepCounter],
					highlighted: false,
					selected: false,
					completed: false,
				}
				stepCounter++
			}
		}
		return newSteps
	}

	let stepStyle
	let currentLocation = parseInt(
		window.location.href.charAt(window.location.href.length - 1)
	)

	const stepsJSX = step.map((step, index) => {
		if (step.completed === true) {
			stepStyle = 'step-number step-number-completed'
		} else if (step.selected === true) {
			stepStyle = 'step-number step-number-active'
		} else {
			stepStyle = 'step-number'
		}

		return (
			<div className='step-wrapper' key={index}>
				<div className={stepStyle}>
					{step.completed ? <span>&#10004;</span> : index + 1}
				</div>
				<div
					className={
						step.selected || step.completed
							? 'step-text step-text-completed'
							: 'step-text'
					}
				>
					{step.description}
				</div>
				<div
					className={
						index !== steps.length - 1
							? currentLocation - 1 > index ||
							  window.location.pathname === '/rate-implicit-calculator/submit'
								? 'divider-blue'
								: 'divider'
							: ''
					}
				/>
			</div>
		)
	})

	return (
		<div id='stepProgressBar' className='stepContainer'>
			{stepsJSX}
		</div>
	)
}
